import { gql } from 'apollo-boost'

const SCRAPING_TEST_CASE_RESULTS = gql`
  query scrapingTestCaseResults(
    $scrapingSessionId: ID!
    $page: Int
    $pageSize: Int
    $validationScoreOrder: ScrapingTestCaseResultValidationScoreOrder
  ) {
    scrapingTestCaseResults(
      scrapingSessionId: $scrapingSessionId
      page: $page
      pageSize: $pageSize
      validationScoreOrder: $validationScoreOrder
    ) {
      scrapingTestCaseResults {
        id
        scrapingResponse {
          id
          type
          response
        }
        scrapingTestCase {
          id
          menuId
          menuUrl
          scrapingInstructions
          scrapedData
          tags {
            id
            name
            type
          }
        }
        newDishes
        missingDishes
        newMenuTitles
        missingMenuTitles
        validationMetrics
        validationStatus
      }
      total
    }
  }
`

export default SCRAPING_TEST_CASE_RESULTS
